export class SolicitudNotasIndexModel{

	constructor(		
		public id:MchSolicitudNotasId,
        public numero_factura:string,
        public nota:number,
        public nombre:string
        ){}        
}


export class SolicitudNotasModel{

	constructor(		
		public id:MchSolicitudNotasId,
        public numeroFactura:string,
        public valor:number,
        public observacion:string,
        public vusuario:string,
        public dfecsist:Date,
        public nota:number
    ){}        
}


export class MchSolicitudNotasId{
	constructor(public cid: string ,public videscritura:string, public cnumcont:string, public cprefijo:string){}
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/SolicitudNotas/SolicitudNotas.model.ts